import styled from "styled-components";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const PricesContainer = styled(RowContainer)`
  gap: 4px;
  width: 100%;
`;

const BedsBathsContainer = styled(RowContainer)`
  gap: 4px;
  width: 100%;
`;

const SelectContainers = styled(RowContainer)`
  flex-direction: column;
  gap: 12px;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 8px;
  }
`;

export {
  FormContainer,
  RowContainer,
  PricesContainer,
  SelectContainers,
  BedsBathsContainer,
};
